import React from "react";
import { Popup } from "semantic-ui-react";
import { useExtLabels } from './extLabels'


const ButtonWithPopup = ({ errors, button }) => {
    const l = useExtLabels()

    return errors ? (
        <Popup
            trigger={button}
            inverted
            content={l("Sprawdź czy wprowadzone dane są kompletne i poprawne.")}
            position="right center"
        />
    ) : (
        button
    );
};

export default ButtonWithPopup;